module.exports = __webpack_public_path__ + "img/IMG_0459.4278179d.jpeg";